"use strict";

function openFacebookShareModal(url, winWidth, winHeight) {
  var winTop = screen.height / 2 - winHeight / 2;
  var winLeft = screen.width / 2 - winWidth / 2;
  window.open('https://www.facebook.com/dialog/share?app_id=554028980187489&display=popup&href=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}
function openTwitterShareModal(url, title, winWidth, winHeight) {
  var winTop = screen.height / 2 - winHeight / 2;
  var winLeft = screen.width / 2 - winWidth / 2;
  window.open('https://twitter.com/intent/tweet?url=' + url + '&text=' + title, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}